// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSortSelector_container__svZaH","label":"ProductSortSelector_label__8USY2","select":"ProductSortSelector_select__GXk4o"};